<template>
  <div class="floating-label" :class="{ 'used': used }">
    <label for="a">{{ label }}</label>
    <input
      :type="type"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :class="inputClass"
      @focus="focus()"
      @blur="blur()">
  </div>
</template>

<script>
  export default {
    name: 'FloatingLabel',

    data() {
      return {
        used: false
      }
    },

    watch: {
      value(newValue, oldValue){
        this.used = newValue.length != 0
      }
    },

    mounted() {
      this.used = this.value.length > 0;
    },

    props: {
      'type': {
        type: String,
        default: 'text'
      },

      'value': {
        type: String,
        default: ''
      },

      'input-class': String,

      'label': String
    },

    methods: {
      focus(){
        this.used = true;
      },

      blur(){
        this.used = this.value.length > 0;
        this.$emit('blur');
      }
    },
  }
</script>

<style lang="scss" scoped>
  .floating-label{
    position: relative;

    label{
      position: absolute;
      opacity: .8;
      top: 15px;
      padding-left: $input-padding-x;
      transition: top .1s ease-in-out;
      pointer-events: none;
    }

    &.used{
      label{
        font-size: 12px;
        top: 5px;
      }

      input{
        padding-top: 15px;
      }
    }
  }
</style>